import { RouteRaw, RoutesObj } from "@/@types";
import usePermission from "@/app/composables/usePermission";
import { useMainStore } from "@/infra/store";

import { PermissionAttributes } from "@/domain/permissions/permissions.types";
import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import { routes } from "./routes";

export const transformRoutes = (routesObj: RoutesObj): RouteRecordRaw[] => {
  return Object.values(routesObj).map(processNode);
};

const processNode = (node: RouteRaw): RouteRecordRaw => {
  const route = {
    ...node,
    children: [],
    // props: true,
  } as RouteRecordRaw;

  for (const key in node) {
    if (key === "path" || key === "name" || key === "children") continue;

    const child = node[key as keyof RouteRaw];
    if (
      typeof child === "object" &&
      child !== null &&
      "path" in child &&
      "name" in child
    ) {
      const processedChild = processNode(child as RouteRaw);
      if (route.children) {
        route.children.push(processedChild);
      }
    }
  }
  return route;
};

const authCheck = () => {
  return useMainStore().session;
};

const router = createRouter({
  history: createWebHistory(""),
  routes: [
    ...transformRoutes(routes),
    {
      path: "/:pathMatch(.*)*",
      redirect: { name: "NotFound" },
    },
  ],
});

router.beforeEach((to, from, next) => {
  const logged = authCheck();
  if (!to.meta.requiresAuth) return next()
  if (!logged) return next(routes.login.path);
  const useHasPermission = usePermission().userHasPermission(to.meta.allowPermission as PermissionAttributes)
  if (useHasPermission) return next()
  next(routes.not_found)
});

export default router;
